import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const { REACT_APP_WS_URL } = process.env;

// Socket singleton para evitar múltiples conexiones
let socketInstance = null;

const getSocket = () => {
  if (!socketInstance) {
    socketInstance = io(REACT_APP_WS_URL, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 20000,
      forceNew: false
    });
  }
  return socketInstance;
};

export const useSocket = (roomId, eventHandlers = {}) => {
  const socket = useRef(null);
  const isConnected = useRef(false);

  useEffect(() => {
    if (!roomId) return;

    socket.current = getSocket();

    // Conectar al room
    socket.current.emit('hello', roomId);
    isConnected.current = true;

    // Configurar event handlers
    Object.entries(eventHandlers).forEach(([event, handler]) => {
      socket.current.on(event, handler);
    });

    // Cleanup
    return () => {
      if (socket.current && isConnected.current) {
        // Remover event handlers
        Object.keys(eventHandlers).forEach(event => {
          socket.current.off(event);
        });
        
        // Salir del room
        socket.current.emit('leave', roomId);
        isConnected.current = false;
      }
    };
  }, [roomId, eventHandlers]);

  const emit = (event, data) => {
    if (socket.current && isConnected.current) {
      socket.current.emit(event, data);
    }
  };

  return { socket: socket.current, emit, isConnected: isConnected.current };
};

export default useSocket; 